import { useSearchParams } from 'react-router-dom';

import ProjectCard from './project-card';
import FilterChips from '../../../common/components/filter-chips/filter-chips';
import PageHeader from '../../../common/components/page-header/page-header';
import SearchField from '../../../common/components/search-field/search-field';
import EmptyState from '../../../common/components/state-message/empty-state';
import ErrorState from '../../../common/components/state-message/error-state';
import LoadingState from '../../../common/components/state-message/loading-state';
import Button from '../../../common/components/button/button';
import { PROJECT_STATE_LABEL } from '../../../core/constants/domain';
import { SEARCH_DEBOUNCE_MS } from '../../../core/constants/routes';
import { useDebouncedValue } from '../../../core/hooks/useDebouncedValue';
import { useProjectsList } from '../contexts/projects';

import '../styles/overview.css';

const STATE_OPTIONS = [
    { value: '', label: 'Todos' },
    { value: 'active', label: PROJECT_STATE_LABEL.active },
    { value: 'paused', label: PROJECT_STATE_LABEL.paused },
    { value: 'closed', label: PROJECT_STATE_LABEL.closed },
];

export default function ProjectsOverview() {
    const [params, setParams] = useSearchParams();
    const q = params.get('q') || '';
    const state = params.get('state') || '';
    const debouncedQ = useDebouncedValue(q.trim(), SEARCH_DEBOUNCE_MS);
    const { data, isPending, isError, error, refetch, isPlaceholderData } = useProjectsList({ q: debouncedQ, state });

    const setParam = (key, value) => {
        const next = new URLSearchParams(params);
        if (value) next.set(key, value);
        else next.delete(key);
        setParams(next, { replace: true });
    };

    const projects = data?.items ?? [];

    return (
        <div className="projects-overview">
            <PageHeader
                eyebrow="Portafolio"
                title="Proyectos"
                description="Cada proyecto con sus repositorios, planes y avance derivado de sus tareas."
            />
            <div className="projects-overview__filters">
                <SearchField
                    label="Buscar proyectos"
                    placeholder="Buscar por nombre o descripción"
                    value={q}
                    onChange={(value) => setParam('q', value)}
                />
                <FilterChips label="Estado del proyecto" options={STATE_OPTIONS} value={state} onChange={(value) => setParam('state', value)} />
            </div>

            <p className="projects-overview__count" aria-live="polite">
                {isPending ? 'Buscando…' : `${data?.total ?? 0} proyectos`}
            </p>

            {isPending && <LoadingState label="Cargando proyectos" rows={4} />}
            {isError && <ErrorState error={error} onRetry={refetch} />}
            {!isPending && !isError && projects.length === 0 && (
                <EmptyState
                    title="Ningún proyecto coincide"
                    description="Prueba con otra palabra o quita el filtro de estado."
                    action={<Button size="small" onClick={() => setParams({}, { replace: true })}>Limpiar filtros</Button>}
                />
            )}
            {projects.length > 0 && (
                <ul className={`projects-overview__grid${isPlaceholderData ? ' projects-overview__grid--refreshing' : ''}`}>
                    {projects.map((project) => <ProjectCard key={project.id} project={project} />)}
                </ul>
            )}
        </div>
    );
}
